import TextInput from './TextInput'
import fillTextInput from './testHelper/fillTextInput'
import expectTextInputValue from './testHelper/expectTextInputValue'
import expectTextInputNotExists from './testHelper/expectTextInputNotExists'

export default TextInput

export { fillTextInput, expectTextInputValue, expectTextInputNotExists }
